import parsePhoneNumberFromString from 'libphonenumber-js/mobile';

export const mobilePhoneValidator = (dirtyMobile: string) => {
  const parsed = parsePhoneNumberFromString(dirtyMobile);
  const isValid = parsed !== undefined && parsed.isPossible();
  return isValid || 'Please enter a valid mobile phone number';
};
